import {NgModule} from '@angular/core';
import {CareproviderUnitUrlResolverService} from '../service/careprovider-unit-url-resolver.service';

@NgModule({
  providers: [CareproviderUnitUrlResolverService],
  exports: [],
})
export class SharedCpruModule {}
